import { useState } from 'react';
import styles from './DebitTab.module.css';

import { useDispatch } from 'react-redux';
import { openModal } from './../../../../redux/slices/modalSlice';
import CheckboxAndData from '../../../../components/CheckboxAndData/CheckboxAndData';
import ClickableButton from '../../../../components/ClickableButton/ClickableButton';
import DynamicTable from '../../../../components/DynamicTable/DynamicTable';

function DebitTab() {
  const [tableData, setTableData] = useState([]); // you can populate this dynamically later

  const tableHeadings = [
    { title: <CheckboxAndData />, accessor: 'checkbox' },
    { title: 'Debit Id', accessor: 'debitId' },
    { title: 'Date Raised', accessor: 'dateRaised' },
    { title: 'Due Date', accessor: 'dueDate' },
    { title: 'Pending', accessor: 'pending' },
    { title: 'Raised Against', accessor: 'raisedAgainst' },
    { title: 'Total', accessor: 'total' },
    { title: 'Payment Date', accessor: 'paymentDate' },
  ];

  const dispatch = useDispatch();
  const tab = [
    {
      label: 'Due',
      content: (
        <div className={styles.DueTab}>
          <div className={styles.buttonRow}>
            <ClickableButton
              label="Add Debit"
              onClick={() => dispatch(openModal('createDebitNotes'))}
            />
          </div>

          <div className={styles.tableWrapper}>
            <DynamicTable headings={tableHeadings} columnData={tableData} />
          </div>
        </div>
      ),
    },
    {
      label: 'Paid',
      content: (
        <div className={styles.DueTab}>
          <div className={styles.buttonRow}>
            <ClickableButton
              label="Add Debit"
              onClick={() => dispatch(openModal('createDebitNotes'))}
            />
          </div>

          <div className={styles.tableWrapper}>
            <DynamicTable headings={tableHeadings} columnData={tableData} />
          </div>
        </div>
      ),
    },
  ];

  const [activeTab, setActiveTab] = useState(tab[0].label);

  return (
    <div className={styles.DebitTab}>
      <div className={styles.maincontainer}>
        <div className={styles.container}>
          {tab.map((item, index) => {
            return (
              <div
                key={index}
                className={`${styles.tabOptions} ${
                  activeTab === item.label && styles.ActivetabOption
                }`}
                onClick={() => setActiveTab(item.label)}
              >
                {item.label}
              </div>
            );
          })}
        </div>
      </div>

      {tab.map((item) =>
        activeTab === item.label ? <>{item.content}</> : null
      )}
    </div>
  );
}

export default DebitTab;
